import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedPipesModule } from '../../shared-pipes';
import { ErrorComponent } from './error.component';

@NgModule({
  imports: [CommonModule, SharedPipesModule],
  declarations: [ErrorComponent],
  exports: [ErrorComponent],
})
export class ErrorModule {}
